import React from 'react';
import CreateLinkForm from './forms/CreateLinkForm';

const CreateLink = () => {
  return <CreateLinkForm />;
};

export default CreateLink;
